export async function getSwiper() {
    return import(/* webpackChunkName: "swiper" */ 'swiper').then(
        ({ Swiper }) => ({
            Swiper,
        }),
    );
}
